import React, {useEffect, useRef, useState} from "react";
import s from "./LocationScroller.module.scss";
import useScrollerDots from "../../hooks/useScrollerDots";

const LocationScroller = ({
                              locations,
                              selected,
                              onSelect
                          }) => {
    const scrollerRef = useRef(null);
    const {
        dots,
        activeDot,
        handleScroll
    } = useScrollerDots(
        scrollerRef,
        [locations]
    );
    const [isDown, setIsDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [centerItems, setCenterItems] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (!scrollerRef.current) return;

            const el = scrollerRef.current;

            setCenterItems(el.scrollWidth <= el.clientWidth);
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);

        return () => window.removeEventListener("resize", checkOverflow);
    }, [locations]);
    useEffect(() => {
        if (!selected || !scrollerRef.current) return;
        const el = scrollerRef.current;
        const selectedItem = el.querySelector(
            `[data-id="${selected.id}"]`
        );
        if (selectedItem) {
            selectedItem.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest"
            });
        }
    }, [selected]);
    const onMouseDown = (e) => {
        const slider = scrollerRef.current;
        setIsDown(true);
        setStartX(
            e.pageX - slider.offsetLeft
        );
        setScrollLeft(
            slider.scrollLeft
        );
    };
    const onMouseLeave = () => {
        setIsDown(false);
    };
    const onMouseUp = () => {
        setIsDown(false);
    };
    const onMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const slider = scrollerRef.current;
        const x =
            e.pageX - slider.offsetLeft;
        const walk =
            (x - startX) * 1.5;
        slider.scrollLeft =
            scrollLeft - walk;
    };
    return (
        <div className={s.wrapper}>
            <div
                ref={scrollerRef}
                className={`${s.scroller} ${centerItems ? s.centered : ""}`}
                onScroll={handleScroll}
                onMouseDown={onMouseDown}
                onMouseMove={onMouseMove}
                onMouseUp={onMouseUp}
                onMouseLeave={onMouseLeave}
            >
                {
                    locations.map(location => (
                        <button
                            key={location.id}
                            data-id={location.id}
                            className={`
                                                            ${s.item}
                                                                                            ${
                                selected?.id === location.id
                                    ? s.active
                                    : ""
                            }
                                                        `}
                            onClick={() => onSelect(location)}
                        >
                            <img
                                src={
                                    location.image ||
                                    "/images/location-placeholder.jpg"
                                }
                                alt={location.name}
                            />
                            <span>
                                {location.name}
                            </span>
                        </button>
                    ))
                }
            </div>
            <div className={s.dotContainer}>
                {
                    Array.from({
                        length: dots
                    }).map((_, index) => (
                        <span
                            key={index}
                            className={`
                                                            ${s.dot}
                                                                                            ${
                                activeDot === index
                                    ? s.activeDot
                                    : ""
                            }
                                                        `}
                        />
                    ))
                }
            </div>
        </div>
    );
};
export default LocationScroller;